"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AbsoluteTime = _interopRequireDefault(require("../Utils/AbsoluteTime"));

var _RelativeTime = _interopRequireDefault(require("../Utils/RelativeTime"));

var _useStyleOptions3 = _interopRequireDefault(require("../hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Timestamp = function Timestamp(_ref) {
  var timestamp = _ref.activity.timestamp,
      ariaHidden = _ref['aria-hidden'],
      className = _ref.className;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      timestampFormat = _useStyleOptions2[0].timestampFormat;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      timestampStyleSet = _useStyleSet2[0].timestamp;

  if (!timestamp) {
    return false;
  }

  return _react.default.createElement("span", {
    "aria-hidden": ariaHidden,
    className: (0, _classnames.default)(timestampStyleSet + '', (className || '') + '')
  }, timestampFormat === 'relative' ? _react.default.createElement(_RelativeTime.default, {
    value: timestamp
  }) : _react.default.createElement(_AbsoluteTime.default, {
    value: timestamp
  }));
};

Timestamp.defaultProps = {
  'aria-hidden': false,
  className: ''
};
Timestamp.propTypes = {
  activity: _propTypes.default.shape({
    timestamp: _propTypes.default.string.isRequired
  }).isRequired,
  'aria-hidden': _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = Timestamp;
exports.default = _default;